import { createSelector } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { State } from './reducer';
import { selectAlarmTypesState } from '../selectors';

export const getData = createSelector(selectAlarmTypesState, (state: State) => state.data);

export const getError = createSelector(selectAlarmTypesState, (state: State) => state.error);

export const getLoading = createSelector(selectAlarmTypesState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ParameterResult[]) => T) =>
  createSelector(selectAlarmTypesState, (state: State) => fn(state.data));
